module.exports = __webpack_public_path__ + "static/media/co-workers.7bc7c41b.png";